import { render, staticRenderFns } from "./ColumnHeader.vue?vue&type=template&id=7626976b&scoped=true&"
import script from "./ColumnHeader.vue?vue&type=script&lang=js&"
export * from "./ColumnHeader.vue?vue&type=script&lang=js&"
import style0 from "./ColumnHeader.vue?vue&type=style&index=0&id=7626976b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7626976b",
  null
  
)

export default component.exports